import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=0fb510f8&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=0fb510f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb510f8",
  null
  
)

export default component.exports